<template>
  <div class="qrcode__container">
    <canvas id="qrcode"></canvas>
  </div>
</template>

<script>
import ReimbursementCode from './ReimbursementCode';

export default ReimbursementCode;
</script>

<style lang="scss">
@import 'ReimbursementCode';
</style>
